import { MarketplacePage } from '../public/MarketplacePage'
export function CompanyDiscoveryPage() { return <MarketplacePage embedded /> }
